/**
 * OrderIntegrations API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  authorizeShopify,
  createOrderIntegration,
  deleteOrderIntegration,
  getOrderIntegrationById,
  getOrderIntegrations,
  syncShopifyOrders,
  updateOrderIntegration,
} from "../generated/order-integrations/order-integrations";

import { wrapListMethod, wrapMethod } from "./utils";

export const orderIntegrations = {
  /** @see authorizeShopify */
  authorizeShopify: wrapMethod(authorizeShopify),

  /** @see syncShopifyOrders */
  syncShopifyOrders: wrapMethod(syncShopifyOrders),

  /** @see createOrderIntegration */
  create: wrapMethod(createOrderIntegration),

  /** @see getOrderIntegrations */
  list: wrapListMethod(getOrderIntegrations),

  /** @see getOrderIntegrationById */
  get: wrapMethod(getOrderIntegrationById),

  /** @see updateOrderIntegration */
  update: wrapMethod(updateOrderIntegration),

  /** @see deleteOrderIntegration */
  delete: wrapMethod(deleteOrderIntegration),
} as const;

export type OrderIntegrationsApi = typeof orderIntegrations;
